import { useEffect } from 'react';


const GoogleAnalytics = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENABLE_ANALYTICS !== 'true') return;


    // Load the external script
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-85NYTKGRPK';
    script.async = true;
    document.head.appendChild(script);


    // Add the inline config script
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-85NYTKGRPK');
    `;
    document.head.appendChild(inlineScript);
  }, []);


  return null;
};


export default GoogleAnalytics;